'use client';

import { c as _c } from "react/compiler-runtime";
import { useIsClient } from 'usehooks-ts';
import ViverseWorldCardBanner from '@/components/ViverseWorldCardBanner';
import ViverseWorldCardDefault from '@/components/ViverseWorldCardDefault';
import { WorldCardProvider } from '@/context/ViverseWorldCardContext';
import { extractRoomIdFromUrl } from '@/lib/cms';
import { isNewRoom, isUpdatedRoom } from '@/lib/viverse-world-card';
import roomDefaultImage from '@/public/images/room-default.png';
import { ViverseWorldCardProps } from '@/types/viverse-world-card';
export default function ViverseWorldCard(t0) {
  const $ = _c(89);
  let banner;
  let className;
  let customDesc;
  let href;
  let imageClassName;
  let imageSizes;
  let info;
  let isExclusive;
  let isHot;
  let isNew;
  let isSelected;
  let isTop;
  let isUpdated;
  let mediaClassName;
  let moreActionContent;
  let noAccess;
  let onAfterMutatingWorld;
  let priority;
  let props;
  let rankingIndex;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== t0) {
    ({
      href,
      info,
      showMoreAction: t1,
      moreActionContent,
      customDesc,
      hideLiked: t2,
      shareOnly: t3,
      isCoOwnedRoom: t4,
      className,
      imageClassName,
      mediaClassName,
      imageSizes,
      onAfterMutatingWorld,
      stopSetAsFeatured: t5,
      hidePremiumBadge: t6,
      ranking: t7,
      rankingIndex,
      cardOnly: t8,
      isNew,
      isUpdated,
      isMission: t9,
      isExclusive,
      isSelected,
      isHot,
      isTop,
      isLive: t10,
      forceShowPremiumBadge: t11,
      disableAutoPreview: t12,
      noAccess,
      cardType: t13,
      priority,
      banner,
      openLinksInNewTab: t14,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = banner;
    $[2] = className;
    $[3] = customDesc;
    $[4] = href;
    $[5] = imageClassName;
    $[6] = imageSizes;
    $[7] = info;
    $[8] = isExclusive;
    $[9] = isHot;
    $[10] = isNew;
    $[11] = isSelected;
    $[12] = isTop;
    $[13] = isUpdated;
    $[14] = mediaClassName;
    $[15] = moreActionContent;
    $[16] = noAccess;
    $[17] = onAfterMutatingWorld;
    $[18] = priority;
    $[19] = props;
    $[20] = rankingIndex;
    $[21] = t1;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
    $[27] = t2;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
  } else {
    banner = $[1];
    className = $[2];
    customDesc = $[3];
    href = $[4];
    imageClassName = $[5];
    imageSizes = $[6];
    info = $[7];
    isExclusive = $[8];
    isHot = $[9];
    isNew = $[10];
    isSelected = $[11];
    isTop = $[12];
    isUpdated = $[13];
    mediaClassName = $[14];
    moreActionContent = $[15];
    noAccess = $[16];
    onAfterMutatingWorld = $[17];
    priority = $[18];
    props = $[19];
    rankingIndex = $[20];
    t1 = $[21];
    t10 = $[22];
    t11 = $[23];
    t12 = $[24];
    t13 = $[25];
    t14 = $[26];
    t2 = $[27];
    t3 = $[28];
    t4 = $[29];
    t5 = $[30];
    t6 = $[31];
    t7 = $[32];
    t8 = $[33];
    t9 = $[34];
  }
  const showMoreAction = t1 === undefined ? false : t1;
  const hideLiked = t2 === undefined ? false : t2;
  const shareOnly = t3 === undefined ? false : t3;
  const isCoOwnedRoom = t4 === undefined ? false : t4;
  const stopSetAsFeatured = t5 === undefined ? false : t5;
  const hidePremiumBadge = t6 === undefined ? true : t6;
  const ranking = t7 === undefined ? false : t7;
  const cardOnly = t8 === undefined ? false : t8;
  const isMission = t9 === undefined ? false : t9;
  const isLive = t10 === undefined ? false : t10;
  const forceShowPremiumBadge = t11 === undefined ? false : t11;
  const disableAutoPreview = t12 === undefined ? false : t12;
  const cardType = t13 === undefined ? "experiences" : t13;
  const openLinksInNewTab = t14 === undefined ? false : t14;
  const {
    image: t15,
    hubs_url,
    owner,
    is_voucher_room,
    vod_duration,
    vod_last_update_date,
    trailer_videos,
    external_link
  } = info;
  const image = t15 === undefined ? roomDefaultImage.src : t15;
  const isClient = useIsClient();
  let t16;
  if ($[35] !== info.first_public_date || $[36] !== isNew) {
    t16 = isNew ?? isNewRoom(info.first_public_date);
    $[35] = info.first_public_date;
    $[36] = isNew;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  const showNew = t16;
  let t17;
  if ($[38] !== info.first_public_date || $[39] !== info.last_updated_at || $[40] !== isUpdated) {
    t17 = isUpdated ?? isUpdatedRoom(info.last_updated_at, info.first_public_date);
    $[38] = info.first_public_date;
    $[39] = info.last_updated_at;
    $[40] = isUpdated;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  const showUpdated = t17;
  const showExclusive = isExclusive ?? info.is_exclusive ?? false;
  const showSelected = isSelected ?? info.is_selected ?? false;
  const showHot = isHot ?? info.is_hot ?? false;
  const showTop = isTop ?? info.is_top ?? false;
  const showPremiumTag = !!(forceShowPremiumBadge || !hidePremiumBadge && is_voucher_room);
  const isVOD = typeof vod_duration === "number" && !!vod_last_update_date;
  const resolvedImage = noAccess ? roomDefaultImage.src : image;
  const vodId = info.vod_id || trailer_videos?.[0]?.vod_id;
  const t18 = banner?.ctaHref || href || external_link || hubs_url || "/";
  let t19;
  if ($[42] !== t18) {
    t19 = extractRoomIdFromUrl(t18);
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  const targetUrl = t19;
  const title = info.title;
  const imageAlt = title ? owner?.display_name ? `${title} by ${owner.display_name}` : title : "";
  const Card = cardType === "banner" ? ViverseWorldCardBanner : ViverseWorldCardDefault;
  let t20;
  if ($[44] !== banner || $[45] !== cardOnly || $[46] !== cardType || $[47] !== customDesc || $[48] !== disableAutoPreview || $[49] !== hideLiked || $[50] !== href || $[51] !== imageAlt || $[52] !== imageClassName || $[53] !== imageSizes || $[54] !== info || $[55] !== isClient || $[56] !== isCoOwnedRoom || $[57] !== isLive || $[58] !== isMission || $[59] !== isVOD || $[60] !== mediaClassName || $[61] !== moreActionContent || $[62] !== noAccess || $[63] !== onAfterMutatingWorld || $[64] !== openLinksInNewTab || $[65] !== priority || $[66] !== ranking || $[67] !== rankingIndex || $[68] !== resolvedImage || $[69] !== shareOnly || $[70] !== showExclusive || $[71] !== showHot || $[72] !== showMoreAction || $[73] !== showNew || $[74] !== showPremiumTag || $[75] !== showSelected || $[76] !== showTop || $[77] !== showUpdated || $[78] !== stopSetAsFeatured || $[79] !== targetUrl || $[80] !== vodId) {
    t20 = {
      targetUrl,
      imageAlt,
      cardType,
      resolvedImage,
      showPremiumTag,
      isVOD,
      vodId,
      href,
      imageClassName,
      mediaClassName,
      imageSizes,
      priority,
      noAccess,
      customDesc,
      moreActionContent,
      hideLiked,
      isCoOwnedRoom,
      showMoreAction,
      shareOnly,
      stopSetAsFeatured,
      onAfterMutatingWorld,
      info,
      isClient,
      disableAutoPreview,
      ranking,
      rankingIndex,
      cardOnly,
      isMission,
      isNew: showNew,
      isUpdated: showUpdated,
      isExclusive: showExclusive,
      isSelected: showSelected,
      isHot: showHot,
      isTop: showTop,
      isLive,
      openLinksInNewTab,
      banner
    };
    $[44] = banner;
    $[45] = cardOnly;
    $[46] = cardType;
    $[47] = customDesc;
    $[48] = disableAutoPreview;
    $[49] = hideLiked;
    $[50] = href;
    $[51] = imageAlt;
    $[52] = imageClassName;
    $[53] = imageSizes;
    $[54] = info;
    $[55] = isClient;
    $[56] = isCoOwnedRoom;
    $[57] = isLive;
    $[58] = isMission;
    $[59] = isVOD;
    $[60] = mediaClassName;
    $[61] = moreActionContent;
    $[62] = noAccess;
    $[63] = onAfterMutatingWorld;
    $[64] = openLinksInNewTab;
    $[65] = priority;
    $[66] = ranking;
    $[67] = rankingIndex;
    $[68] = resolvedImage;
    $[69] = shareOnly;
    $[70] = showExclusive;
    $[71] = showHot;
    $[72] = showMoreAction;
    $[73] = showNew;
    $[74] = showPremiumTag;
    $[75] = showSelected;
    $[76] = showTop;
    $[77] = showUpdated;
    $[78] = stopSetAsFeatured;
    $[79] = targetUrl;
    $[80] = vodId;
    $[81] = t20;
  } else {
    t20 = $[81];
  }
  let t21;
  if ($[82] !== Card || $[83] !== className || $[84] !== props) {
    t21 = <Card {...props} className={className} />;
    $[82] = Card;
    $[83] = className;
    $[84] = props;
    $[85] = t21;
  } else {
    t21 = $[85];
  }
  let t22;
  if ($[86] !== t20 || $[87] !== t21) {
    t22 = <WorldCardProvider value={t20}>{t21}</WorldCardProvider>;
    $[86] = t20;
    $[87] = t21;
    $[88] = t22;
  } else {
    t22 = $[88];
  }
  return t22;
}